import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-22",
  "use": "icon-button_icon-22-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 24\" id=\"icon-button_icon-22\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M11.083 22H5.04C3.361 22 2 20.698 2 19.09V4.91C2 3.301 3.361 2 5.04 2h12.92C19.639 2 21 3.302 21 4.91v3.51\" stroke-linecap=\"round\" /><circle cx=\"19.5\" cy=\"14.5\" r=\"2.75\" /><path d=\"M25 23c0-2.761-2.462-5-5.5-5S14 20.239 14 23M6 13.74h7M6 8.5h10\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol